import { alpha } from "@mui/material";
import { Theme } from "@mui/material/styles";

const scannedMediaObjectRowStyle = {
  link: {
    color: "#137f7b",
    textDecoration: "none",
  },
  borderLess: {
    "& td": {
      border: "none",
      paddingBottom: 0,
    },
  },
  additionalRow: {
    "& td": {
      paddingTop: 0,
    },
  },
  warning: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.error.main, 0.05),
    "& > td:first-of-type": {
      borderLeft: `0.25rem solid ${theme.palette.error.main}`,
    },
  }),
};

export default scannedMediaObjectRowStyle;
